(function () {
  'use strict';
  if (window.__pqSwatches) return;
  window.__pqSwatches = true;

  function setVariant(a, id) {
    try {
      var u = new URL(a.getAttribute('href'), window.location.href);
      u.searchParams.set('variant', id);
      a.setAttribute('href', u.pathname + u.search);
    } catch (e) {}
  }

  function cardImg(card) {
    return (
      card.querySelector(`.card-gallery slideshow-slide[aria-hidden='false'] img`) ||
      card.querySelector('.card-gallery .product-media-container img') ||
      card.querySelector('.card-gallery img')
    );
  }

  function sizesFor(img) {
    return Math.max(120, Math.round(img.clientWidth || 360)) + 'px';
  }

  /* Download a colour's photo in advance (same candidate the card will use), once per dot */
  function load(b, img) {
    if (b._pqReady) return b._pqReady;
    var src = b.getAttribute('data-src');
    if (!src || !img) {
      b._pqReady = Promise.resolve(false);
      return b._pqReady;
    }
    var srcset = b.getAttribute('data-srcset');
    b._pqReady = new Promise(function (resolve) {
      var pre = new Image();
      pre.onload = function () { resolve(true); };
      pre.onerror = function () { resolve(false); };
      pre.sizes = sizesFor(img);
      if (srcset) pre.srcset = srcset;
      pre.src = src;
    });
    return b._pqReady;
  }

  function preloadGroup(group) {
    if (!group || group._pqPre) return;
    var card = group.closest('product-card');
    var img = card && cardImg(card);
    if (!img) return;
    group._pqPre = true;
    group.querySelectorAll('.pq-swatch').forEach(function (b) { load(b, img); });
  }

  /* Start downloading as soon as someone hovers the card (mouse) or touches the dots (phone/tablet) */
  document.addEventListener('pointerover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var g = t.closest('.pq-swatches');
    if (!g && e.pointerType === 'mouse') {
      var c = t.closest('product-card');
      g = c && c.querySelector('.pq-swatches');
    }
    if (g) preloadGroup(g);
  }, { capture: true, passive: true });
  document.addEventListener('touchstart', function (e) {
    var t = e.target;
    var g = t && t.closest && t.closest('.pq-swatches');
    if (g) preloadGroup(g);
  }, { capture: true, passive: true });
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    var g = t && t.closest && t.closest('.pq-swatches');
    if (g) preloadGroup(g);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var more = t.closest('.pq-swatches__more');
    if (more) {
      e.preventDefault();
      e.stopPropagation();
      more.closest('.pq-swatches').classList.add('is-open');
      return;
    }

    var b = t.closest('.pq-swatch');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();

    var card = b.closest('product-card');
    if (!card) return;

    var group = b.parentNode;
    group.querySelectorAll('.pq-swatch').forEach(function (x) {
      x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
    });

    var id = b.getAttribute('data-variant');
    if (id) {
      card.querySelectorAll(`a[href*='/products/']`).forEach(function (a) { setVariant(a, id); });
    }

    var img = cardImg(card);
    var src = b.getAttribute('data-src');
    if (!img || !src) return;

    /* dim the photo right away so the tap feels instant, then swap as soon as the new photo is ready */
    img.style.transition = 'opacity .2s ease';
    img.style.opacity = '.45';
    var token = (card._pqToken = (card._pqToken || 0) + 1);

    preloadGroup(group);
    load(b, img).then(function (ok) {
      if (token !== card._pqToken) return;
      var show = function () { img.style.opacity = '1'; };
      if (!ok) { show(); return; }
      img.sizes = sizesFor(img);
      var srcset = b.getAttribute('data-srcset');
      if (srcset) img.srcset = srcset;
      img.src = src;
      if (img.decode) img.decode().then(show, show);
      else show();
    });
  }, true);
})();
